import React from 'react';
import Svg from '@bibliocommons/svg';

export default function AvailableGroupIcon() {
  return (
    <Svg width="12" height="12" viewBox="0 0 12 12">
      <circle cx="6" cy="6" r="6" fill="#008000" fillRule="evenodd" />
    </Svg>
  );
}
